import { render, staticRenderFns } from "./transferDialog.vue?vue&type=template&id=53db3c39&scoped=true&"
import script from "./transferDialog.vue?vue&type=script&lang=js&"
export * from "./transferDialog.vue?vue&type=script&lang=js&"
import style0 from "./transferDialog.vue?vue&type=style&index=0&id=53db3c39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53db3c39",
  null
  
)

export default component.exports